import styled, { css } from 'styled-components';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';

export const StyledSection = styled(Section)`
  display: flex;
  flex-direction: column;
  background: var(--Shades-0, #fff);
  padding: 0px !important;
  ${media.md`
    padding-bottom:0px !important;

     
    
  `} ${media.lg`
     padding: 40px 0px !important;
    
  `} ${media.xl`
     padding:0px !important;
    
    
  `};
`;

export const StyledContentBlock = styled(ContentBlock)`
  display: flex;

  align-items: flex-start;
  align-self: stretch;

  width: auto !important;
  flex-direction: column !important;
  padding: 0px 20px 40px 20px;
  padding-bottom: 40px !important;

  align-items: center;
  gap: 8px;
  ${media.md`
    flex-direction: column !important;
    gap:40px;
    padding: 0px 44px 60px 44px;
    padding-bottom: 0px !important;
    
    align-items: center;

    
  `}
  ${media.lg`
    flex-direction: row-reverse !important;
    padding-bottom: 80px !important;
    
    gap:20px;
    
  `};
  ${media.xl`
    gap: 20px;
    padding: 50px 60px 100px !important;
    
  `};
`;

export const Contentwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
  margin-top: 16px;
  text-align: center;
  ${media.md`
    gap: 32px;
    text-align: unset;

    
  `}
  ${media.xl`
    gap: 40px;
    margin-top: unset;

    
  `}
`;

export const Title = styled.h1`
  color: var(--Shades-900, #1c1c1c);
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  font-size: ${props => (props.locale === 'ru' ? '35px' : '40px')};
  font-style: normal;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  line-height: 85%;
  letter-spacing: -0.8px;
  text-transform: uppercase;
  align-self: stretch;
  margin: 0px;
  ${media.md`
    font-size: 70px;
    letter-spacing: -1.4px;
    
  `}
  ${props =>
    media.lg`${css`
      font-size: ${props.locale === 'ru' ? '75px' : '90px'};
      letter-spacing: ${props.locale === 'ru' ? '-1.4px' : '-1.8px'};
    `}`}
  ${props =>
    media.xl`${css`
      font-size: ${props.locale === 'ru' ? '70px' : '110px'};
      letter-spacing: ${props.locale === 'ru' ? '-1.4px' : '-2.2px'};
    `}`}
`;

export const Subtitle = styled.p`
  color: var(--Shades-700, #67656e);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.32px;
  align-self: stretch;
  margin: 0px;
  ${media.md`
    font-size: 22px;
 
    line-height: 123%; 
  `}
  ${media.lg`
    font-size: 25px;

    
  `}
  ${media.xl`
    font-size: 28px;
    max-width:680px;
    
  `}
`;

export const QrWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--radius-sml, 20px);
  ${media.md`
    gap: var(--radius-sml, 10px);
    
  `}
  ${media.xl`
    gap: var(--radius-sml, 20px);
    
  `}
`;

export const ApptoreButton = styled.a`
  display: none;
  ${media.md`
    display: flex;
    width: 176.167px;
    height: 56px;
    
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    border: 2.333px solid #1c1c1c;
  `}
`;

export const GooglplayButton = styled.a`
  display: none;
  ${media.md`
    display: flex;
    width: 176.167px;
    height: 56px;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    border: 2.333px solid #1c1c1c;
  `}
`;

export const MobileButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 56px);
  background: #ff9500;
  border-radius: 116.162px;
  padding: 14px 28px;
  gap: 9.293px;
  height: 20px;
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 110%;
  margin: 0px;
  text-align: center;
  cursor: pointer;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  ${media.md`
    display:none;
  `}
`;

export const QrIcon = styled.img`
  display: none;
  ${media.md`
    display: flex;
    width: 56px;
    height: 56px;
    padding: 8px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;
    cursor:pointer;
  `}
`;

export const Icon = styled.img`
  width: 111.811px;
  height: 26px;
  flex-shrink: 0;
`;

export const TotalImageWrapper = styled.img`
  display: none;

  ${media.lg`
    display: flex;
    height: 477px;
    width:410px;
    border-radius: 16.463px;
    
  `}
  ${media.xl`
    display: flex;
    height: 536.14px;
    border-radius: 16.463px;
    width: auto !important;
  `}
`;

export const TotalImageWrapperTablet = styled.img`
  display: none;
  ${media.md`
    display: flex;

 
    border-radius: 16.463px;
    width: 100% !important;
    height:350px;
  `}
  ${media.lg`
    display: none;

    
  `}
`;

export const TotalImageWrapperMobile = styled.img`
  display: flex;

  border-radius: 16.463px;
  width: 236px;
  height: 243px;
  ${media.md`
    display: none;

    
  `};
`;

export const BackGroundWrapper = styled.div`
  width: 100%;
  height: 210px;
  flex-shrink: 0;
  border-radius: 16.463px;
  background: var(--Orange-100, #ffe2c8);
  align-self: stretch;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  ${media.md`
    width:100%;
    height: 313px;
    margin-bottom: unset;
    display: unset;
    justify-content: unset;

    
  `}
  ${media.lg`
    width: 410px;
    height: 430px;

    
  `}
  ${media.xl`
    width: 523px;
    height: 484px;

    
  `}
`;
